var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgFileTypesMov(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 24
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h24v24H0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#EDF1F7",
    d: "M21 6h-5.25a.75.75 0 01-.75-.75V0H4.125C3.505-.002 3.002.5 3 1.12v21.755c-.002.62.5 1.123 1.12 1.125h15.755c.62.002 1.123-.5 1.125-1.12V6z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F7F9FC",
    d: "M20.672 4.922L16.082.328A1.122 1.122 0 0015.286 0H15v5.25c0 .414.336.75.75.75H21v-.286a1.12 1.12 0 00-.328-.792z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6 10.8h12v12H6z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#C5CEE0",
    d: "M14.724 16.473l-4.126-2.591c-.335-.21-.848-.006-.848.514v5.18c0 .468.477.749.848.515l4.126-2.591c.368-.23.369-.798 0-1.028z"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(.6 2.4)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 7.2,
    fill: "#FF463D",
    rx: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    fillRule: "nonzero",
    d: "M1.361 5.331v-2.52l.853 1.672h.537l.882-1.682v2.53h.536V1.953h-.633L2.497 3.966 1.478 1.953H.825v3.378h.536zm5.075.083c.335 0 .624-.072.868-.217.244-.144.429-.35.556-.616.126-.267.19-.579.19-.936 0-.368-.067-.684-.2-.951a1.418 1.418 0 00-.563-.61 1.669 1.669 0 00-.85-.209c-.336 0-.625.072-.869.217-.243.145-.429.35-.555.617-.127.266-.19.578-.19.936 0 .367.066.684.2.95.133.267.32.47.562.61.243.14.526.21.851.21zm0-.497c-.328 0-.578-.108-.75-.324-.173-.216-.259-.532-.259-.948 0-.416.086-.732.258-.949.173-.216.423-.324.751-.324s.579.108.75.324c.173.217.26.533.26.949 0 .416-.087.732-.26.948-.171.216-.422.324-.75.324zm3.642.414l1.228-3.378h-.633l-.898 2.793-.901-2.793H8.22l1.23 3.378h.629z"
  })))));
}

export default SvgFileTypesMov;